//REACT
import React, { useEffect } from "react"
//ROUTER-DOM
import { useLocation, useNavigate } from "react-router-dom"
//REDUX-TOOLKIT
import { useUserActions } from "../../../store/user/userAction"
//FORMIK & YUP
import { Formik, Form } from "formik"
import * as Yup from "yup"
//COMPONENTS
import AuthLayoutTitle from "../../../components/title/AuthLayoutTitle"
import LoadingButton from "../../../components/button/LoadingButton"
import FormikInput from "../../../components/FormikInput"
//UTILS
import AuthHeader from "../../../components/auth/AuthHeader"
import PasswordStrengthBar from "react-password-strength-bar"
import { errorAlert } from "../../../utils/alerts"

export default function ResetPassword(): JSX.Element {
    const { userForgetPassword } = useUserActions()

    const initialValues = {
        password: "",
        confirmPassword: "",
    }

    const validationSchema = Yup.object().shape({
        password: Yup.string()
            .min(8, "Must be at least 8 characters")
            .matches(/[a-z]/, "Must have at least 1 lowercase letter")
            .matches(/[A-Z]/, "Must have at least 1 uppercase letter")
            .matches(/[0-9]/, "Must have at least 1 number")
            .matches(/^[A-Za-z0-9!@#$%^&*]+$/, 'Password must only contain specified characters !@#$%^&*')
            .matches(/[!@#$%^&*]/, "Must have at least 1 symbol")
            .required("Password is required"),
        confirmPassword: Yup.string()
            .oneOf([Yup.ref("password"), undefined], "Passwords must match")
            .required("Confirm Password is required"),
    })

    const navigate = useNavigate()
    const location = useLocation()


    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token');

    const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false)
    const [resetSuccess, setResetSuccess] = React.useState(false);

    const handleSubmit = async (values) => {
        // enter the submitting
        setIsSubmitting(true)

        const data = {
            newPassword: values.password,
            confirmPassword: values.confirmPassword,
            token: token
        }

        const response = await userForgetPassword(data);

        if (response.data.status) {
            setResetSuccess(true);
            return
        }
        errorAlert(response.data.message)
        setIsSubmitting(false)
    }

    const { userLogout } = useUserActions()

    const handleLogout = (): void => {
        // dispatch redux
        userLogout()
    }
    const [password, setPassword] = React.useState<string>("")

    useEffect(() => {
        if (!token) {
            navigate('/auth/forgot-password')
        }
    })


    return (
        <>
            {resetSuccess ?
                <div className="h-full flex items-center flex-col gap-16 w-full md:w-[30rem]">
                    <div className="flex flex-col gap-3 ">
                        <AuthLayoutTitle title="Reset Password Success!" />
                        <AuthHeader
                            title={"Go to login page and login to your account with new password."}
                        />

                    </div>
                    <LoadingButton
                        className="w-full"
                        onClick={() => navigate('/auth/login')}
                    >
                        Sign-in
                    </LoadingButton>
                </div>
                :
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ handleChange, errors, values, touched, setFieldValue, setFieldTouched }) => (
                        <Form className="h-full flex items-center flex-col gap-16 w-full md:w-[30rem]">
                            <div className="flex flex-col gap-3 ">
                                <AuthLayoutTitle title="Reset your Password" />
                                <div className="flex flex-row items-center justify-center gap-2 text-secondary text-center text-xs lg:text-sm md:leading-6">
                                    <p>
                                        Type and confirm a secure new password for<br />the account
                                    </p>
                                </div>
                            </div>
                            <div className="w-full flex flex-col gap-3">


                                <div className="flex flex-col gap-2">
                                    <FormikInput
                                        label="New Password"
                                        type={"password"}
                                        name={"password"}
                                        placeholder={"Enter your new password"}
                                        onChange={(
                                            e: React.ChangeEvent<HTMLInputElement>
                                        ) => {
                                            
                                            !touched.password && setFieldTouched('password', true)
                                            handleChange(e)
                                            setPassword(e.target.value)
                                            
                                        }}
                                        
                                        setFieldValue={setFieldValue}
                                        value={values.password}
                                        error={errors.password && touched.password ? errors.password : ''}
                                        isEyeShow={true}
                                    />

                                    <div className="flex flex-col gap-3">
                                        <p className="text-secondary text-xs md:text-sm">
                                            Required atleast 8 characters. 1 lower case letter, 1 upper case letter, 1 number & 1 special character (!@#$%^&*).
                                        </p>
                                        <PasswordStrengthBar
                                            password={password}
                                            minLength={8}
                                            className="text-secondary"
                                        />
                                    </div>
                                </div>

                                <FormikInput
                                    label="Confirm New Password"
                                    type={"password"}
                                    name={"confirmPassword"}
                                    placeholder={"Enter your confirm password"}
                                    onChange={(
                                        e: React.ChangeEvent<HTMLInputElement>
                                    ) => {
                                        !touched.confirmPassword && setFieldTouched('confirmPassword', true)
                                        handleChange(e)
                                        
                                    }}
                                    setFieldValue={setFieldValue}
                                    value={values.confirmPassword}
                                    error={errors.confirmPassword && touched.confirmPassword ? errors.confirmPassword : ''}
                                    isEyeShow={true}
                                />

                            </div>


                            <LoadingButton
                                className="w-full"
                                loading={isSubmitting}
                                loadingType="circular"
                                buttonType="submit"
                            >
                                Reset
                            </LoadingButton>

                            <button
                                onClick={handleLogout}
                            >
                                {"<"}&nbsp; <span className="underline">Go Back</span>
                            </button>
                        </Form>
                    )}
                </Formik>
            }
        </>
    )
}
